import { render, staticRenderFns } from "./DataRow.vue?vue&type=template&id=6ebb3754&scoped=true&"
import script from "./DataRow.vue?vue&type=script&lang=js&"
export * from "./DataRow.vue?vue&type=script&lang=js&"
import style0 from "./DataRow.vue?vue&type=style&index=0&id=6ebb3754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebb3754",
  null
  
)

export default component.exports